import React, {Component} from 'react';
import ReoContactCenter from "../../components/tables/reoContactCenter";
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import Panel from "../../components/panel";


export default class ContactCenter extends Component{

  constructor(props){
    super(props);
    var userData = JSON.parse(localStorage.getItem("userData"));
    this.state = {userData: userData}
  }

  render(){
    return <div>
      <SidebarMenuRouters profile="/direction-home/" place=""/>
      <Header userName={this.state.userData.name}/>
      <div className={'col-md-12'}>
        <div className='d-flex justify-content-start'>
          <iframe width="1880" height="2500"
                  src={'https://app.powerbi.com/view?r=eyJrIjoiYWY5YTEyOTMtNmJjNC00YmEyLTk0MzEtYmY1Y2IxMGYzZDExIiwidCI6IjM3MjliZThjLTFlYjEtNDRmMS05ZmQ0LWNlZGRiMjA0NjYzZSJ9'} frameBorder="0" allowFullScreen="true"/>
        </div>
        {/*<Panel title={'Reporte de eventos de operación del contact center'}>
          <ReoContactCenter striped={true} bordered={true}/>
        </Panel>*/}
      </div>
    </div>
  }

}



// WEBPACK FOOTER //
// ./src/scene/common/contactCenter.js